export default __webpack_public_path__ + "images/cdd98c513e1ba346d794da4558fbd0f1-visa.svg";